// extracted by mini-css-extract-plugin
export default {"container":"PanelInfo_container__Q6qHO"};